@for (step of steps; track $index) { @switch (step.type) { @case(formType.REGION) {
<app-cod-region-step [regionForm]="regionForm!"></app-cod-region-step>
}@case(formType.REFERENCE_NUMBER_DOMESTIC) {
<app-cod-reference-number-domestic-step
    [referenceNumberDomesticForm]="referenceNumberDomesticForm!"
></app-cod-reference-number-domestic-step>
}@case(formType.REFERENCE_NUMBER_INTERNATIONAL) {
<app-cod-reference-number-international-step
    [referenceNumberInternationalForm]="referenceNumberInternationalForm!"
></app-cod-reference-number-international-step>
}@case(formType.AFFECTED_ITEMS) {
<app-cod-affected-items-step
    [affectedItemsForm]="affectedItemsForm!"
    [formGroup]="formGroup!"
    [readonly]="readonly"
    [complaint]="
        referenceNumberDomesticForm.controls.natureOfComplaint.value ||
        referenceNumberInternationalForm.controls.natureOfComplaint.value
    "
></app-cod-affected-items-step>
}@case(formType.AFFECTED_ITEMS_QUANTITY_DOMESTIC) {
<app-cod-affected-items-quantity-domestic-step
    [affectedItemsForm]="affectedItemsForm!"
    [form]="itemOrQuantityDomesticForm"
></app-cod-affected-items-quantity-domestic-step>
}@case(formType.AFFECTED_ITEMS_QUANTITY_INTERNATIONAL) {
<app-cod-affected-items-quantity-international-step
    [affectedItemsForm]="affectedItemsForm!"
    [form]="itemOrQuantityInternationalForm"
></app-cod-affected-items-quantity-international-step>
}@case(formType.AFFECTED_ITEMS_DAMAGE_DOMESTIC) {
<app-cod-affected-items-damage-domestic-step
    [affectedItemsForm]="affectedItemsForm!"
    [form]="productDamageDomesticForm"
></app-cod-affected-items-damage-domestic-step>
}@case(formType.AFFECTED_ITEMS_DAMAGE_INTERNATIONAL) {
<app-cod-affected-items-damage-international-step
    [affectedItemsForm]="affectedItemsForm!"
    [form]="productDamageInternationalForm"
></app-cod-affected-items-damage-international-step>
}@case(formType.AFFECTED_ITEMS_INVOICE_ERROR_INTERNATIONAL) {
<app-cod-affected-items-invoice-error-international-step
    [affectedItemsForm]="affectedItemsForm!"
    [form]="invoiceErrorInternationalForm"
></app-cod-affected-items-invoice-error-international-step>
}@case(formType.AFFECTED_ITEMS_QUALITY) {
<app-cod-affected-items-quality-step
    [affectedItemsForm]="affectedItemsForm!"
    [form]="qualityInternationalForm"
></app-cod-affected-items-quality-step>
}@case(formType.AFFECTED_ITEMS_ORDER_ENTRY_DOMESTIC) {
<app-cod-affected-items-order-entry-domestic-step
    [affectedItemsForm]="affectedItemsForm!"
    [form]="orderEntryDomesticForm"
></app-cod-affected-items-order-entry-domestic-step>
}@case(formType.ORDER_ENTRY_DOMESTIC) {
<app-cod-order-entry-domestic-step
    [orderEntryDomesticForm]="orderEntryDomesticForm!"
></app-cod-order-entry-domestic-step>
} @case(formType.ORDER_ENTRY_INTERNATIONAL) {
<app-cod-order-entry-international-step
    [orderEntryInternationalForm]="orderEntryInternationalForm!"
></app-cod-order-entry-international-step>
} @case(formType.ITEM_OR_QUANTITY_DOMESTIC) {
<app-cod-item-or-quantity-domestic-step
    [itemOrQuantityDomesticForm]="itemOrQuantityDomesticForm!"
></app-cod-item-or-quantity-domestic-step>
}@case(formType.ITEM_OR_QUANTITY_INTERNATIONAL) {
<app-cod-item-or-quantity-international-step
    [itemOrQuantityInternationalForm]="itemOrQuantityInternationalForm!"
></app-cod-item-or-quantity-international-step>
}@case(formType.PRODUCT_DATING_DOMESTIC) {
<app-cod-product-dating-domestic-step
    [productDatingDomesticForm]="productDatingDomesticForm!"
></app-cod-product-dating-domestic-step>
} @case(formType.PRODUCT_DATING_INTERNATIONAL) {
<app-cod-product-dating-international-step
    [productDatingInternationalForm]="prodcutsDatingInternationalForm!"
></app-cod-product-dating-international-step>
} @case(formType.PRODUCT_DAMAGE_DOMESTIC) {
<app-cod-product-damage-domestic-step
    [productDamageDomesticForm]="productDamageDomesticForm!"
></app-cod-product-damage-domestic-step>
} @case(formType.PRODUCT_DAMAGE_INTERNATIONAL) {
<app-cod-product-damage-international-step
    [productDamageInternationalForm]="productDamageInternationalForm!"
></app-cod-product-damage-international-step>
}@case(formType.PRODUCT_TEMPERATURE_DOMESTIC) {
<app-cod-product-temperature-domestic-step
    [productTemperatureDomesticForm]="prodcutTemperatureDomesticForm!"
></app-cod-product-temperature-domestic-step>
}@case(formType.PRODUCT_TEMPERATURE_INTERNATIONAL) {
<app-cod-product-temperature-international-step
    [productTemperatureInternationalForm]="prodcutTemperatureInternationalForm!"
></app-cod-product-temperature-international-step>
}@case(formType.DELIVERY_ERROR_DOMESTIC) {
<app-cod-delivery-error-domestic-step
    [deliverErrorDomesticForm]="deliveryErrorDomesticForm!"
></app-cod-delivery-error-domestic-step>
} @case(formType.DELIVERY_ERROR_INTERNATIONAL) {
<app-cod-delivery-error-international-step
    [deliveryErrorInternationalForm]="deliveryErrorInternationalForm!"
></app-cod-delivery-error-international-step>
}@case(formType.DOCUMENTATION_INTERNATIONAL) {
<app-cod-documentation-international-step
    [documentationInternationalForm]="documentationInternationalForm!"
></app-cod-documentation-international-step>
}@case(formType.INVOICE_ERROR_DOMESTIC) {
<app-cod-invoice-error-domestic-step
    [invoiceErrorDomesticForm]="invoiceErrorDomesticForm!"
></app-cod-invoice-error-domestic-step>
}@case(formType.INVOICE_ERROR_INTERNATIONAL) {
<app-cod-invoice-error-international-step
    [invoiceErrorInternationalForm]="invoiceErrorInternationalForm!"
></app-cod-invoice-error-international-step>
}@case(formType.BILLING_ADJUSTMENT_DOMESTIC) {
<app-cod-billing-adjustment-domestic-step
    [billingAdjustmentDomesticForm]="billingAdjustmentDomesticForm!"
></app-cod-billing-adjustment-domestic-step>
}@case(formType.QUALITY_INTERNATIONAL) {
<app-cod-quality-international-step
    [qualityInternationalForm]="qualityInternationalForm!"
></app-cod-quality-international-step>
}@case(formType.ESKER_DISCREPANCY_DOMESTIC) {
<app-cod-esker-discrepancy-domestic-step
    [eskerDiscrepancyDomesticForm]="eskerDiscrepancyForm!"
></app-cod-esker-discrepancy-domestic-step>
}@case(formType.LARGE_INSTRUMENT_WAREHOUSE_DISCREPANCY) {
<app-cod-large-instrument-warehouse-discrepancy-step
    [largeInstrumentWarehouseDiscrepancyForm]="largeInstrumentWarehouseDiscrepancyForm!"
></app-cod-large-instrument-warehouse-discrepancy-step>
} } }
